import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
type ModalType = 'privacy' | 'terms' | null;
const privacyContent = `
Política de Privacidad — Longevidad Activa 35+

Última actualización: Febrero 2026

1. Información que Recopilamos
Recopilamos únicamente la información necesaria para procesar tu compra y entregarte el producto digital: nombre, correo electrónico y datos de pago.

2. Uso de la Información
Tu información se utiliza exclusivamente para:
• Procesar y entregar tu compra.
• Enviarte actualizaciones relacionadas con el producto adquirido.
• Mejorar nuestros servicios y experiencia de usuario.

3. Protección de Datos
Implementamos medidas de seguridad técnicas y organizativas para proteger tu información personal contra acceso no autorizado, alteración o destrucción.

4. Compartir Información
No vendemos, alquilamos ni compartimos tu información personal con terceros, excepto cuando sea necesario para procesar pagos a través de plataformas seguras.

5. Cookies
Nuestro sitio puede utilizar cookies para mejorar la experiencia de navegación. Puedes desactivarlas en la configuración de tu navegador.

6. Tus Derechos
Tienes derecho a acceder, rectificar o eliminar tu información personal en cualquier momento contactándonos directamente.

7. Cambios en esta Política
Nos reservamos el derecho de actualizar esta política. Los cambios serán publicados en esta página con la fecha de actualización correspondiente.
`.trim();
const termsContent = `
Términos y Condiciones — Longevidad Activa 35+

Última actualización: Febrero 2026

1. Aceptación de los Términos
Al adquirir "Longevidad Activa 35+", aceptas estos términos y condiciones en su totalidad.

2. Naturaleza del Producto
Este es un producto digital educativo (PDF) sobre hábitos de bienestar y optimización. No constituye consejo médico, diagnóstico ni tratamiento. Consulta siempre a un profesional de salud antes de realizar cambios significativos en tu estilo de vida.

3. Entrega del Producto
El producto se entrega de forma digital e inmediata tras la confirmación del pago. Recibirás acceso por correo electrónico.

4. Política de Reembolso
Ofrecemos una garantía de 7 días. Si no estás satisfecho/a con el producto, puedes solicitar un reembolso completo dentro de los 7 días posteriores a la compra.

5. Propiedad Intelectual
Todo el contenido del producto está protegido por derechos de autor. Queda prohibida su reproducción, distribución o reventa sin autorización expresa.

6. Limitación de Responsabilidad
Los resultados pueden variar según cada persona. No garantizamos resultados específicos. El usuario es responsable de la aplicación del contenido.

7. Uso Aceptable
El producto es para uso personal únicamente. No está permitido compartir, copiar o distribuir el material a terceros.

8. Modificaciones
Nos reservamos el derecho de modificar estos términos. Las actualizaciones serán efectivas desde su publicación en esta página.
`.trim();
export function Footer() {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  return <>
      <footer className="bg-[#060606] border-t border-white/5 py-6 md:py-8" data-id="element-100">
        <div className="max-w-4xl mx-auto px-4 flex flex-col items-center gap-3 md:gap-4" data-id="element-101">
          <div className="flex items-center gap-4 md:gap-6" data-id="element-102">
            <button onClick={() => setActiveModal('privacy')} className="text-xs md:text-sm text-gray-500 hover:text-cyan-400 transition-colors" data-id="element-103">
              Política de Privacidad
            </button>
            <span className="text-gray-700" data-id="element-104">•</span>
            <button onClick={() => setActiveModal('terms')} className="text-xs md:text-sm text-gray-500 hover:text-cyan-400 transition-colors" data-id="element-105">
              Términos y Condiciones
            </button>
          </div>
          <p className="text-[10px] md:text-xs text-gray-600" data-id="element-106">
            © {new Date().getFullYear()} Biohacking Esencial. Todos los
            derechos reservados.
          </p>
        </div>
      </footer>

      {/* Modal Overlay */}
      <AnimatePresence data-id="element-107">
        {activeModal && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2
      }} className="fixed inset-0 z-50 flex items-end md:items-center justify-center p-0 md:p-4 bg-black/80 backdrop-blur-sm" onClick={() => setActiveModal(null)} data-id="element-108">
            <motion.div initial={{
          opacity: 0,
          y: 40
        }} animate={{
          opacity: 1,
          y: 0
        }} exit={{
          opacity: 0,
          y: 40
        }} transition={{
          duration: 0.25
        }} onClick={e => e.stopPropagation()} className="bg-[#111] border border-white/10 rounded-t-2xl md:rounded-2xl w-full max-w-2xl max-h-[85vh] md:max-h-[80vh] overflow-hidden shadow-2xl" data-id="element-109">
              {/* Modal Header */}
              <div className="flex items-center justify-between p-4 md:p-6 border-b border-white/10" data-id="element-110">
                <h3 className="text-lg md:text-xl font-bold text-white" data-id="element-111">
                  {activeModal === 'privacy' ? 'Política de Privacidad' : 'Términos y Condiciones'}
                </h3>
                <button onClick={() => setActiveModal(null)} className="text-gray-400 hover:text-white transition-colors p-1 rounded-lg hover:bg-white/10" data-id="element-112">
                  <X size={20} data-id="element-113" />
                </button>
              </div>

              {/* Modal Body */}
              <div className="p-4 md:p-6 overflow-y-auto max-h-[calc(85vh-70px)] md:max-h-[calc(80vh-80px)]" data-id="element-114">
                <pre className="text-gray-300 text-xs md:text-sm leading-relaxed whitespace-pre-wrap font-sans" data-id="element-115">
                  {activeModal === 'privacy' ? privacyContent : termsContent}
                </pre>
              </div>
            </motion.div>
          </motion.div>}
      </AnimatePresence>
    </>;
}